export interface InformationalMessageProps {
  message: string;
}

const InformationalMessage = ({ message }: InformationalMessageProps) => (
  <div className="mt-10 flex justify-center rounded-sm bg-muted-white p-4 dark:bg-design-black-accent">
    {message}
  </div>
);

export default InformationalMessage;
